<!--
  @Description: 
  @Author: wang.y 
  @Date: 2024-07-27 
-->
<template>
  <div class="main-header">
    <span>
      <slot></slot>
    </span>
    <!-- <img :src="static_img_url+'pic/vbef.png?v=' + $store.state.imgVersion" /> -->
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
    }),
  },
}
</script>
<style lang='stylus' scoped>
.main-header
  padding-top 0.2rem
  padding-bottom 0.2rem
  border-bottom 1px solid #eeeeee
  display flex
  justify-content space-between
  align-items center
  margin 0 0.4rem
  font-weight 700
  span
    font-size 0.36rem
    line-height 0.6rem
    color #333333
  img
    height 0.6rem
</style>